import $ from "jquery";
import { netwerkInitMap, networkDataAttributeBuilder } from "./mapHelper";

function hexToRgba(hex, opacity) {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, "");

  // Parse r, g, b values
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  // Return RGBA string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function isHexColor(hex) {
  return /^#[0-9A-F]{6}$/i.test(hex);
}

function rgbaToHex(rgba) {
  // Extract the RGB values using a regular expression
  var matches = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*\d*\.\d+)?\)/);

  if (!matches) {
    throw new Error("Invalid RGBA color format");
  }

  // Convert the RGB values to hexadecimal
  var r = parseInt(matches[1]).toString(16).padStart(2, "0");
  var g = parseInt(matches[2]).toString(16).padStart(2, "0");
  var b = parseInt(matches[3]).toString(16).padStart(2, "0");

  // Return the combined hex string
  return `#${r}${g}${b}`;
}

function isRGBA(color) {
  // Regular expression to match RGBA format
  var rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*\d*\.\d+)?\)$/;

  // Check if the color string matches the RGBA regex
  return rgbaRegex.test(color);
}

/**
 * Generates active search tags
 */
export const searchBubble = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  const params = new URLSearchParams(url.search);
  const existingTags = params.get("tags");
  const existingDates = params.get("dates");
  const existingKeywords = params.get("keywords");
  const existingTagsArray = existingTags ? existingTags.split(",") : [];
  const existingDatesArray = existingDates ? existingDates.split(",") : [];

  let html = "";
  let hasFilter = false;
  // console.log("yyy", existingTagsArray);
  if (existingTags) {
    existingTagsArray.forEach((tag) => {
      html += `<div class="activeFilterBubble">${tag} <span class="removeFilter" data-value="${tag}">x</span></div>`;
    });
    hasFilter = true;
  }
  if (existingKeywords) {
    html += `<div class="activeFilterBubble">${existingKeywords} <span class="removeFilter" data-value="${existingKeywords}">x</span></div>`;
    hasFilter = true;
  }
  if (existingDatesArray.length > 0) {
    existingDatesArray.forEach((date) => {
      // console.log({ date });
      const formattedDate = dayjs.unix(date).format("MMM 'YY");
      html += `<div class="activeFilterBubble">${formattedDate} <span class="removeFilter" data-value="${date}">x</span></div>`;
    });
    hasFilter = true;
  }
  if (hasFilter) {
    html +=
      '<div class="clearAllFilter" tabindex="0" role="button">WIS ALLE FILTERS</div>';
  }
  $(".searchbubble").html(html);
};

/**
 * Removes item from the filter list in the url
 */
export const removeFilterFromURL = (wordToRemove) => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url.search);

  for (const [key, value] of params) {
    // console.log("hi");
    console.log({ key });
    // Split the value by commas to handle multiple values
    const values = value.split(",");
    console.log({ values });

    // Filter out the word you want to remove
    const filteredValues = values.filter((v) => v !== wordToRemove.toString());

    // Join the filtered values back into a single string
    const filteredValue = filteredValues.join(",");
    console.log({ filteredValue });

    // Set the updated value back in the URLSearchParams
    params.set(key, filteredValue);
    url.search = params.toString();
  }

  // const updatedSearch = params.toString();

  // Update the URL search with the modified parameters
  history.replaceState(null, null, url.toString());
  searchBubble();
};

/**
 * grab the actual filter form the URL
 * @returns
 */
export const getFilterFromURL = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  let filter = {};

  const params = new URLSearchParams(url.search);
  const existingTags = params.get("tags");
  const existingDates = params.get("dates");
  const existingKeywords = params.get("keywords");

  if (existingTags) {
    const tagsToArray = existingTags ? existingTags.split(",") : [];
    const newTagArray = [];
    tagsToArray.forEach((tag) => {
      newTagArray.push(tag);
    });
    filter.tags = newTagArray;
  }

  if (existingDates) {
    const datetoArray = existingDates ? existingDates.split(",") : [];
    const newDateArray = [];
    datetoArray.forEach((date) => {
      newDateArray.push(dayjs.unix(date).format("MM-YYYY"));
    });
    filter.dates = newDateArray;
  }

  if (existingKeywords) {
    filter.keywords = existingKeywords;
  }

  return filter;
};

export const tagsBubble = () => {
  var hasFilter = false;
  const tags = sessionStorage.getItem("networktags");
  const search = sessionStorage.getItem("networksearchtags");
  const thema = sessionStorage.getItem("thematags");
  let html = "";

  if (tags) {
    const jsonTags = JSON.parse(tags);
    // console.log("xxx", jsonTags.tags); // This will output: ["booyah"]
    if (jsonTags.tags.length > 0) {
      hasFilter = true;
      jsonTags.tags.forEach((tag) => {
        html += `<div class="activeFilterBubble !inline-block mt-4 removeFilterNetwork cursor-pointer" data-expertise="${tag}" tabindex="0">${tag} <span class="">x</span></div>`;
      });
    }
  } else {
    sessionStorage.setItem("networktags", JSON.stringify({ tags: [] }));
  }
  if (thema) {
    const jsonTags = JSON.parse(thema);
    // console.log("xxx", jsonTags.tags); // This will output: ["booyah"]
    if (jsonTags.thema.length > 0) {
      hasFilter = true;
      // jsonTags.thema.forEach((tag) => {
      //   html += `<div class="activeFilterBubble !inline-block mt-4">${tag} <span class="removeFilterThema cursor-pointer" data-thema="${tag}">x</span></div>`;
      // });
    }
  } else {
    sessionStorage.setItem("thematags", JSON.stringify({ thema: [] }));
  }
  if (search) {
    html += `<div class="activeFilterBubble !inline-block mt-4 removeSearchNetwork cursor-pointer" data-search="${search}" tabindex="0">${search} <span class="">x</span></div>`;
    hasFilter = true;
  } else {
    sessionStorage.setItem("networksearchtags", "");
  }

  if (hasFilter) {
    html +=
      '<div class="clearAllFilterNetwork !inline-block mt-4" tabindex="0" role="button">WIS ALLE FILTERS</div>';
  }

  const tagsBubbleElement = document.querySelectorAll(".tagsbubble");

  tagsBubbleElement.forEach((element) => {
    element.innerHTML = html;
  });

  clearAllFilterNetwork();
  removeFilterNetwork();
  lookForFilteredNetworks();
  removeSearchNetwork();
  return;
};

/**
 * Clears all filter network
 */
export const clearAllFilterNetwork = () => {
  const clearAllFilterNetworkElement = document.querySelectorAll(
    ".clearAllFilterNetwork"
  );

  // console.log("xxx clearAllFilterNetwork");

  if (clearAllFilterNetworkElement) {
    clearAllFilterNetworkElement.forEach((element) => {
      element.addEventListener("click", function () {
        // console.log("xxx clearning filter network");
        const tags = sessionStorage.getItem("networktags");
        const themas = sessionStorage.getItem("thematags");
        const jsonTags = JSON.parse(tags);
        const jsonThemas = JSON.parse(themas);

        // uncheck checkboxes
        const checkboxes = document.querySelectorAll(".thematag");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        jsonTags.tags = [];
        jsonThemas.thema = [];
        sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
        sessionStorage.setItem("thematags", JSON.stringify(jsonThemas));
        sessionStorage.setItem("networksearchtags", "");
        tagsBubble();
        netwerkInitMap();
        resetFilteredNetwork();
      });

      element.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          // console.log("xxx clearning filter network");
          const tags = sessionStorage.getItem("networktags");
          const themas = sessionStorage.getItem("thematags");
          const jsonTags = JSON.parse(tags);
          const jsonThemas = JSON.parse(themas);

          // uncheck checkboxes
          const checkboxes = document.querySelectorAll(".thematag");
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });

          jsonTags.tags = [];
          jsonThemas.thema = [];
          sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
          sessionStorage.setItem("thematags", JSON.stringify(jsonThemas));
          sessionStorage.setItem("networksearchtags", "");
          tagsBubble();
          netwerkInitMap();
          resetFilteredNetwork();
        }
      });
    });
  }
};

export const resetFilteredNetwork = () => {
  console.log("reseting");

  const buttonElement = document.getElementById("dropdownMenuMap");
  buttonElement.textContent = "Kies een wijk";

  const newNetworks = [];
  const networks = document.querySelectorAll(".netwerk-info");
  networks.forEach((network) => {
    let colour = network.getAttribute("data-colour");
    const initialColour = network.getAttribute("data-colour");

    // switch (colour) {
    //   case "rgba(166, 144, 108, 0.5)":
    //     colour = "#A6906C"; //gold
    //     break;
    //   case "rgba(7, 137, 65, 0.5)": //green
    //     colour = "#078941";
    //     break;
    //   case "rgba(23, 94, 199, 0.5)": //blue
    //     colour = "#175EC7";
    //     break;
    //   case "rgba(201, 76, 4, 0.5)": //orange
    //     colour = "#C94C04";
    //     break;
    //   case "rgba(66, 17, 74, 0.5)": //dark purple
    //     colour = "#42114A";
    //     break;
    //   case "rgba(140, 78, 55, 0.5)": //brown
    //     colour = "#8C4E37";
    //     break;
    //   case "rgba(147, 94, 181, 0.5)": //purple
    //     colour = "#935EB5";
    //     break;
    //   case "rgba(213, 36, 165, 0.5)": //pink
    //     colour = "#D524A5";
    //     break;
    //   case "rgba(0, 0, 0, 0.5)": //black
    //     colour = "#000000";
    //     break;
    //   default:
    //     colour = initialColour;
    //     break;
    // }
    // network.setAttribute("data-colour", colour);

    // if (isRGBA(colour)) {
    //   var newColour = rgbaToHex(colour);
    //   network.setAttribute("data-colour", newColour);
    // }
    // else {
    //   colour = initialColour;
    //   network.setAttribute("data-colour", colour);
    // }

    newNetworks.push(network);
  });
  // console.log("its in resetFilteredNetwork")
  listFilteredNetworkInformation(newNetworks);
};

/**
 *
 */
export const removeFilterNetwork = () => {
  const removeFilterNetworkElement = document.querySelectorAll(
    ".removeFilterNetwork"
  );
  const removeFilterThemaElement =
    document.querySelectorAll(".removeFilterThema");
  removeFilterNetworkElement.forEach((networkTag) => {
    networkTag.addEventListener("click", function () {
      const tags = sessionStorage.getItem("networktags");
      const jsonTags = JSON.parse(tags);
      const expertise = networkTag.getAttribute("data-expertise");
      // console.log("xxx click");
      // Remove the expertise tag from the jsonTags.tags array
      jsonTags.tags = jsonTags.tags.filter((tag) => tag !== expertise);

      // Save the updated jsonTags to sessionStorage
      sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
      tagsBubble();
    });
    networkTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const tags = sessionStorage.getItem("networktags");
        const jsonTags = JSON.parse(tags);
        const expertise = networkTag.getAttribute("data-expertise");
        // console.log("xxx click");
        // Remove the expertise tag from the jsonTags.tags array
        jsonTags.tags = jsonTags.tags.filter((tag) => tag !== expertise);

        // Save the updated jsonTags to sessionStorage
        sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
        tagsBubble();
      }
    });
  });
  removeFilterThemaElement.forEach((themaTag) => {
    themaTag.addEventListener("click", function () {
      const tags = sessionStorage.getItem("thematags");
      const jsonTags = JSON.parse(tags);
      const themas = themaTag.getAttribute("data-thema");
      // console.log("xxx click");
      // Remove the expertise tag from the jsonTags.tags array
      jsonTags.thema = jsonTags.thema.filter((thema) => thema !== themas);

      // Save the updated jsonTags to sessionStorage
      sessionStorage.setItem("thematags", JSON.stringify(jsonTags));
      tagsBubble();
    });

    themaTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const tags = sessionStorage.getItem("thematags");
        const jsonTags = JSON.parse(tags);
        const themas = themaTag.getAttribute("data-thema");
        // console.log("xxx click");
        // Remove the expertise tag from the jsonTags.tags array
        jsonTags.thema = jsonTags.thema.filter((thema) => thema !== themas);

        // Save the updated jsonTags to sessionStorage
        sessionStorage.setItem("thematags", JSON.stringify(jsonTags));
        tagsBubble();
      }
    });
  });
};

export const removeSearchNetwork = () => {
  const removeSearchFilter = document.querySelectorAll(".removeSearchNetwork");
  removeSearchFilter.forEach((search) => {
    search.addEventListener("click", function () {
      sessionStorage.setItem("networksearchtags", "");
      tagsBubble();
    });

    search.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        sessionStorage.setItem("networksearchtags", "");
        tagsBubble();
      }
    });
  });
};

/**
 * the actual function to look for filtered network
 *
 */

export const lookForFilteredNetworks = () => {
  console.log("xxx look for networks");
  const networks = document.querySelectorAll(".netwerk-info");
  const tags = sessionStorage.getItem("networktags");
  const themas = sessionStorage.getItem("thematags");
  const search = sessionStorage.getItem("networksearchtags");
  const jsonTags = JSON.parse(tags);
  const jsonThemas = JSON.parse(themas);
  const newNetworks = [];
  const filteredNetworks = [];
  let searchResultFound = false;

  if (search !== "") {
    networks.forEach((network) => {
      const networkName = network.getAttribute("data-name").toLocaleLowerCase();
      const networkBody = network.getAttribute("data-body").toLocaleLowerCase();

      if (
        networkName.includes(search.toLocaleLowerCase()) ||
        networkBody.includes(search.toLocaleLowerCase())
      ) {
        searchResultFound = true;
        filteredNetworks.push(network);
      } else {
        //no result found.
      }
    });
  }

  if (jsonTags.tags.length > 0 || jsonThemas.thema.length > 0) {
    const allTags = [...jsonTags.tags, ...jsonThemas.thema];
    console.log("all tags", allTags);

    networks.forEach((network) => {
      const expertise = network.getAttribute("data-tagswijk");
      const expertiseJson = JSON.parse(expertise);

      const thema = network.getAttribute("data-tagsthema");
      const themaJson = JSON.parse(thema);

      const combinedTags = [...expertiseJson, ...themaJson];

      let colour = network.getAttribute("data-colour");
      const initialColour = network.getAttribute("data-colour");

      // const tagFound = allTags.some((tag) => combinedTags.includes(tag));

      // Get the selected tags
      const selectedTagsWijk = jsonTags.tags;
      const selectedTagsThema = jsonThemas.thema;

      // Check if tags from both categories are selected
      const hasSelectedTagsWijk = selectedTagsWijk.length > 0;
      const hasSelectedTagsThema = selectedTagsThema.length > 0;

      let tagFound;

      if (hasSelectedTagsWijk && hasSelectedTagsThema) {
        // Both categories have selected tags, show networks with both tags
        tagFound =
          selectedTagsWijk.every((tag) => expertiseJson.includes(tag)) &&
          selectedTagsThema.every((tag) => themaJson.includes(tag));
      } else if (hasSelectedTagsWijk) {
        // Only "tagswijk" is selected
        tagFound = selectedTagsWijk.some((tag) => expertiseJson.includes(tag));
      } else if (hasSelectedTagsThema) {
        // Only "tagsthema" is selected
        tagFound = selectedTagsThema.some((tag) => themaJson.includes(tag));
      } else {
        // If neither are selected, show networks matching any tag
        tagFound = allTags.some(
          (tag) => expertiseJson.includes(tag) || themaJson.includes(tag)
        );
      }

      if (!tagFound) {
        // switch (colour) {
        //   case '#A6906C': //gold
        //     colour = 'rgba(166, 144, 108, 0.5)';
        //     break;
        //   case '#078941': //green
        //     colour = 'rgba(7, 137, 65, 0.5)';
        //     break;
        //   case '#175EC7': //blue
        //     colour = 'rgba(23, 94, 199, 0.5)';
        //     break;
        //   case '#C94C04': //orange
        //     colour = 'rgba(201, 76, 4, 0.5)';
        //     break;
        //   case '#42114A': //dark purple
        //     colour = 'rgba(66, 17, 74, 0.5)';
        //     break;
        //   case '#8C4E37': //brown
        //     colour = 'rgba(140, 78, 55, 0.5)';
        //     break;
        //   case '#935EB5': //purple
        //     colour = 'rgba(147, 94, 181, 0.5)';
        //     break;
        //   case '#D524A5': //pink
        //     colour = 'rgba(213, 36, 165, 0.5)';
        //     break;
        //   case '#000000': //black
        //     colour = 'rgba(0, 0, 0, 0.5)';
        //     break;
        //   default:
        //     colour = initialColour;
        //     break;
        // }
        // if (isHexColor(colour)) {
        //   var newColour = hexToRgba(colour, '0.5');
        //   network.setAttribute("data-colour", newColour);
        // }
        // else {
        //   colour = initialColour;
        //   network.setAttribute("data-colour", colour);
        // }
      }

      if (tagFound) {
        // switch (colour) {
        //   case "rgba(166, 144, 108, 0.5)":
        //     colour = "#A6906C"; //gold
        //     break;
        //   case "rgba(7, 137, 65, 0.5)": //green
        //     colour = "#078941";
        //     break;
        //   case "rgba(23, 94, 199, 0.5)": //blue
        //     colour = "#175EC7";
        //     break;
        //   case "rgba(201, 76, 4, 0.5)": //orange
        //     colour = "#C94C04";
        //     break;
        //   case "rgba(66, 17, 74, 0.5)": //dark purple
        //     colour = "#42114A";
        //     break;
        //   case "rgba(140, 78, 55, 0.5)": //brown
        //     colour = "#8C4E37";
        //     break;
        //   case "rgba(147, 94, 181, 0.5)": //purple
        //     colour = "#935EB5";
        //     break;
        //   case "rgba(213, 36, 165, 0.5)": //pink
        //     colour = "#D524A5";
        //     break;
        //   case "rgba(0, 0, 0, 0.5)": //black
        //     colour = "#000000";
        //     break;
        //   default:
        //     colour = initialColour;
        //     break;
        // }
        // network.setAttribute("data-colour", colour);

        // if (isRGBA(colour)) {
        //   var newColour = rgbaToHex(colour);
        //   network.setAttribute("data-colour", newColour);
        // }
        // else {
        //   colour = initialColour;
        //   network.setAttribute("data-colour", colour);
        // }
        filteredNetworks.push(network);
      }
      newNetworks.push(network);
    });
  }

  if (
    (jsonTags.tags.length > 0 || jsonThemas.thema.length > 0) &&
    searchResultFound
  ) {
    const filteredNetworksSearch = [];

    $(filteredNetworks).each(function () {
      const $el = $(this);
      const tags = JSON.parse($el.attr("data-tagswijk") || "[]");
      const themas = JSON.parse($el.attr("data-tagsthema") || "[]");
      const name = $el.data("name")?.toLowerCase() || "";
      const body = $el.data("body")?.toLowerCase() || "";
      const address = $el.data("address")?.toLowerCase() || "";

      const allTagsMatch = jsonTags.tags.every((tag) => tags.includes(tag));
      const allThemasMatch = jsonThemas.thema.every((thema) =>
        themas.includes(thema)
      );

      const searchTerm = search?.toLowerCase() || "";
      const matchesSearch =
        name.includes(searchTerm) ||
        body.includes(searchTerm) ||
        address.includes(searchTerm);

      // If there is a search, only add if it matches
      if (allTagsMatch && allThemasMatch && (!searchTerm || matchesSearch)) {
        if (!filteredNetworksSearch.includes(this)) {
          filteredNetworksSearch.push(this);
        }
      }
    });
    listFilteredNetworkInformation(filteredNetworksSearch);
  } else {
    listFilteredNetworkInformation(filteredNetworks);
  }

  if (
    jsonTags.tags.length === 0 &&
    jsonThemas.thema.length === 0 &&
    search === ""
  ) {
    const filteredPartnerInformationList = document.getElementById(
      "filtered-network-information-list"
    );

    if (filteredPartnerInformationList) {
      const partnerInformationList = document.getElementById(
        "partner-information-list"
      );
      filteredPartnerInformationList.classList.add("hidden");
      partnerInformationList.classList.remove("hidden");
    }
  }

  // console.log("newNetworks", newNetworks);
  // console.log("filteredNetworks", filteredNetworks);
};

export const listFilteredNetworkInformation = (listNetworks) => {
  let htmllist = "";
  const filterMapView = [];

  // console.log(listNetworks);

  /** map view: filtered result first network ============ */
  // const partnerInformation = document.getElementById("partner-information");
  // partnerInformation.innerHTML = renderNetworkInformation(networks[0]);
  const partnerInformation = document.getElementById("partner-information");

  if ($(".maplist-slick-slider").hasClass("slick-initialized")) {
    $(".maplist-slick-slider").slick("unslick");
  }
  // Clear existing content (optional, depends on your use case)
  partnerInformation.innerHTML = "";

  if (listNetworks.length === 0) {
    partnerInformation.innerHTML += renderNetworkInformationNoLoca();
  } else {
    listNetworks.forEach((network) => {
      partnerInformation.innerHTML += renderNetworkInformation(network);
    });
  }
  /** end map view: filtered result first network ============ */

  /** list and markers:  ============ */
  listNetworks.forEach((network, index) => {
    // htmllist += renderNetworkInformationList(network, index);
    //push the relevant data to the array so that we can generate a new map view
    filterMapView.push(networkDataAttributeBuilder(network));
  });

  /** end list and markers ============ */

  /** this re-renders the marker on the network map ============ */
  var netwerkMapCanvas = document.getElementById("netwerk-map");

  if (netwerkMapCanvas) {
    // console.log("what", filterMapView);
    netwerkInitMap(filterMapView);
  }
  /** end this re-renders the marker on the network map ============ */

  const partnerInformationList = document.getElementById(
    "partner-information-list"
  );

  const filteredPartnerInformationList = document.getElementById(
    "filtered-network-information-list"
  );

  if (filteredPartnerInformationList) {
    filteredPartnerInformationList.innerHTML = htmllist;
    filteredPartnerInformationList.classList.remove("hidden");
    partnerInformationList.classList.add("hidden");
  }

  slickMap();
};

function slickMap() {
  console.log("trigger slick");
  $(".maplist-slick-slider").slick({
    dots: true,
    infinite: false,
    adaptiveHeight: true,
    rows: 2,
    slidesPerRow: 2,
    prevArrow: $(".maplist-slick-wrapper .slider-control .prev"),
    nextArrow: $(".maplist-slick-wrapper .slider-control .next"),
    appendDots: $(".count-wrap"),
    customPaging: function (slider, i) {
      var currentSlide = i + 1;
      var totalSlides = slider.slideCount;
      return currentSlide + " van " + totalSlides;
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesPerRow: 1,
          rows: 2,
        },
      },
    ],
  });
}

export const renderNetworkInformation = (network) => {
  let html = "";
  var name = network.getAttribute("data-name");
  var body = network.getAttribute("data-body");
  var colour = network.getAttribute("data-colour");
  var address = network.getAttribute("data-address");
  var url = network.getAttribute("data-url");
  var tags = [];
  if (network.getAttribute("data-tagswijk") != "") {
    tags = JSON.parse(network.getAttribute("data-tagswijk"));
  } else {
    // tags = "";
  }

  let tagHtml = "";

  if (tags.length > 0) {
    tags.forEach((tag) => {
      tagHtml +=
        '<div class="tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-cirBlack bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">';
      tagHtml += `<span class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] font-degularText uppercase">${tag}</span>`;
      tagHtml += "</div>";
    });
  }

  // html += '<div class="maplist-slick-slider">';
  html +=
    '<div class="py-5 lg:p-5 eachCardPartner"><div class="items-center gap-8 kenn">';
  html += `
  <h2
    style="color: ${colour};"
    class="partner-name text-[26px] scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-bold pb-2"
  >${name}</h2>`;
  html += `</div>`;

  html +=
    '<div class="partner-body font-normal pb-4 font-degularText text-lg scale-text-150:text-xl scale-text-200:text-2xl">';
  html += `${body}`;
  html += "</div>";

  html +=
    '<div class="font-degular font-medium text-[18px] scale-text-150:text-[20px] scale-text-200:text-[24px] not-italic py-4">';
  html += `<div class="partner-address">${address}</div>`;
  html += `</div>`;

  html += `<a
  href="${url}"
  target="_blank"
  rel="noopener noreferrer"
  class="partner-website-button origin-left scale-75 md:scale-100 flex items-center hover-arrow arrow-icon-after-white cursor-pointer hover:no-underline w-fit h-[40px] text-white py-2.5 px-6 rounded-full"
  style="background-color: ${colour};"
>
  Bekijk alles
</a>`;

  html += "</div>";
  return html;
};

export const renderNetworkInformationList = (network, index) => {
  let html = "";
  var name = network.getAttribute("data-name");
  var body = network.getAttribute("data-body");
  var colour = network.getAttribute("data-colour");
  var address = network.getAttribute("data-address");
  var url = network.getAttribute("data-url");
  var tags = [];
  if (network.getAttribute("data-tagswijk") != "") {
    tags = JSON.parse(network.getAttribute("data-tagswijk"));
  } else {
    // tags = "";
  }

  let tagHtml = "";

  if (tags.length > 0) {
    tags.forEach((tag) => {
      tagHtml +=
        '<div class="tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-cirBlack bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">';
      tagHtml += `<span class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] font-degularText uppercase">${tag}</span>`;
      tagHtml += "</div>";
    });
  }

  html += `<div class="flex flex-col justify-between h-full">
        <div>
          <div class="items-center gap-8">
            <h2 class="partner-name text-[26px] scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-degularText font-bold pb-2">
              ${name}
            </h2>
          </div>

          <div class="partner-body font-normal pb-4 font-degularText text-lg scale-text-150:text-xl scale-text-200:text-2xl">
          ${body}
          </div>

          <div class="netwerk-tags">
          ${tagHtml}
          </div>


          <div class="font-degular font-medium text-[18px] scale-text-150:text-[20px] scale-text-200:text-[24px] not-italic py-4">
            <div class="partner-address">${address}</div>
          </div>
        </div>


        <a
          href="${url}"
          target="_blank"
          rel="noopener noreferrer"
          class="partner-website-button origin-left scale-75 md:scale-100 flex items-center hover-arrow arrow-icon-after-white cursor-pointer hover:no-underline w-fit h-[40px] text-white py-2.5 px-6 rounded-full"
          style="background-color: ${colour};"
        >
          Bekijk alles
        </a>

      </div>`;

  return html;
};

export const renderNetworkInformationNoLoca = () => {
  let html = "";

  // html += '<div class="maplist-slick-slider">';
  html +=
    '<div class="py-5 lg:p-5 eachCardPartner"><div class="items-center gap-8 kenn">';
  html += `
  <h2
    class="partner-name text-[26px] text-cirBlack scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-bold pb-2"
  >No Location</h2>`;
  html += `</div>`;

  html += "</div>";
  return html;
};
